module.exports = "/deep/ .ui-tooltip {\n  max-width: 700px;\n  white-space:pre-wrap;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-application/srp-form/workrequest-srp/workrequest-srp.component.css
// module id = ./src/app/create-application/srp-form/workrequest-srp/workrequest-srp.component.css
// module chunks = main